import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class OrganizationMembersResource extends BaseResource {
  constructor() {
    super({ url: '/api/organisations/members' });
  }

  search(params) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/search${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
